import { MainAppResource } from './base';

export default function SubstationFeederDiagrams({ projectCode, substationCode, agentCode }) {
  return MainAppResource(
    `api/v3/projects/${projectCode}/substations/${substationCode}/agents/${agentCode}/diagrams{/code}`
  );
}
